import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import MathBlockNodeView from './MathBlockNodeView';

export const MathBlock = Node.create({
  name: 'mathBlock',

  group: 'block',
  content: 'text*',
  code: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      formula: {
        default: '',
      },
      comment: {
        default: '', // NEW!
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="math-block"]',
        getAttrs: (el) => {
          const element = el as HTMLElement;
          return {
            formula: element.getAttribute('formula') ?? '',
            comment: element.getAttribute('comment') ?? '',
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, { 'data-type': 'math-block' }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(MathBlockNodeView);
  },

  addCommands(): any {
    return {
      insertMathBlock:
        (formula: string, comment = '') =>
        ({ commands }: { commands: any }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { formula, comment },
          });
        },
    };
  },
});
